import LocalizedStrings from 'react-localization';

class Strings {
  static COMMON = new LocalizedStrings({
    'en-US': {
      ok: 'OK',
      done: 'Done',
      submit: 'Submit',
      tryAgain: 'Try Again',
      hourShort: 'hr',
      hoursShort: 'hrs',
      minutesShort: 'min',
      daysDiffOne: 'Day',
      daysDiffOther: 'Days',
      hour: 'Hour',
      hours: 'Hours',
      notificationTitle: 'What have you just been doing?',
      notificationBody: 'Take a breather and log your last hour’s work.',
      acceptingInvitation: 'We are processing your invitation. Please wait...',
      lifetime: 'Lifetime',
    },
  });

  static LOGIN = new LocalizedStrings({
    'en-US': {
      emailHint: 'Email',
      passwordHint: 'Password',
      logIn: 'Log In',
      forgotPassword: 'Forgot your password?',
      signUp: 'Sign Up',
      bySigningUp1: 'By signing up you agree to iworkie’s ',
      bySigningUp2: ' and ',
      terms: 'Terms of Service',
      privacy: 'Privacy Policy',
    },
  });

  static WELCOME = new LocalizedStrings({
    'en-US': {
      nameBrief: 'It’s always great to know who we’re talking to.',
      firstNameHint: 'First Name',
      lastNameHint: 'Last Name',
      getStarted: 'Get Started',
    },
  });

  static MOBILE_BLOCK = new LocalizedStrings({
    'en-US': {
      header:
        'To get the best experience from iworkie on a mobile device please install the iworkie App from the relevant app store.',
      getApp: 'Get The iworkie App',
      body:
        'iworkie’s web view is meant to compliment the app, and give you more views and tools relevant to a desktop experience.',
      continue: 'Continue anyway',
    },
  });

  static DASHBOARD = new LocalizedStrings({
    'en-US': {
      activity: 'Activity',
      timer: 'Timer',
      history: 'History',
      projects: 'Projects',
      settings: 'Settings',
      logOut: 'Log out',
    },
  });

  static ACTIVITY = new LocalizedStrings({
    'en-US': {
      today: 'Today',
      export: 'Export',
      project: 'Project',
      projects: 'Projects',
      logHours: 'Log Hours',
      emptyTitle: 'Come on! Time to get rolling!',
      emptyBody: 'Grab that cup of coffee and get motivated.',
      failedTitle: 'Failed to fetch todays activity',
      failedBody: 'Please check your internet connection and try again.',
    },
  });

  static ADD_TIME = new LocalizedStrings({
    'en-US': {
      addNewLog: 'Add New Log',
      editLog: 'Edit Log',
      timeLogged: 'Time Logged: ',
      submitLog: 'Submit Log',
      submitChanges: 'Submit Changes',
      deleteLog: 'Delete Log',
      startingAt: 'Starting at:',
      endingAt: 'Ending at:',
      notesPlaceholder: 'Add any optional notes to this log',
    },
  });

  static SELECT_PROJECT = new LocalizedStrings({
    'en-US': {
      selectProject: 'Select a Project',
      newProject: '+ New Project',
      selectProjectEmptyBody:
        'Create a new project using the “+New Project” button above.',
    },
  });

  static TIMER = new LocalizedStrings({
    'en-US': {
      timer: 'Timer',
      activeTimer: 'Active Timer',
      timerHeader: 'Pick the project you want to time.',
      startTimer: 'Start Timer',
      stopTimer: 'Stop Timer',
      resumeTimer: 'Resume Timer',
      logRecordedTime: 'Log Recorded Time',
      logInfoText: 'You can edit this time in your activity log.',
      logInfoMin: 'Must log a minimum of 1 minute.',
      discardTime: 'Discard this time',
      discardModalTitle: 'Are you sure?',
      discardModalBody:
        'Discarding your time will lose the recorded time completely.',
      discardModalButton: 'Discard',
    },
  });

  static HISTORY = new LocalizedStrings({
    'en-US': {
      title: 'History',
      export: 'Export',
      stats: 'Stats for',
      timeLogged: 'Time Logged:',
      numberOfProjects: '# of Projects:',
      earnings: 'Earnings:',
    },
  });

  static HISTORY_DETAILS = new LocalizedStrings({
    'en-US': {
      logHours: 'Log Hours',
      emptyTitle: 'Nothing to see here!',
      emptyBody: 'Once you log some projects your activity will be visible.',
      emptyFutureTitle: 'Hey Nostradamus!',
      emptyFutureBody:
        'We’re smart, but we can’t predict the future yet. This day will be filled in when you get there.',
      pickDate: 'Pick a day to view your logged tasks.',
    },
  });

  static PROJECTS = new LocalizedStrings({
    'en-US': {
      yourProjects: 'Your Projects',
      addProject: '+ Add Project',
      activeProjects: 'Active Projects',
      archivedProjects: 'Archived Projects',
      activeProjectsEmptyTitle: 'You currently have no active projects.',
      activeProjectsEmptyBody:
        'Create a new project using the “+Add Project” button above.',
      archivedProjectsEmptyTitle: 'You currently have no archived projects.',
      archivedProjectsEmptyBody:
        'Archive active projects to remove them from view, but keep any logged information.',
      failedTitle: 'Failed to fetch projects',
      failedBody: 'Please check your internet connection and try again.',
      noResultMatchingTitle: 'No result matching your search',
      noResultMatchingBody: 'Edit your search above to find your project',
    },
  });

  static PROJECT_DETAILS = new LocalizedStrings({
    'en-US': {
      projectInfo: 'Project Info',
      export: 'Export',
      projectOwner: 'Owner - ',
      projectNotes: 'Project notes:',
      created: 'Created:',
      hourlyRate: 'Hourly Rate:',
      currency: 'Currency:',
      archived: 'Archived:',
      projectStats: 'Project stats',
      daysActive: 'Days Active:',
      totalHours: 'Total Hours:',
      generatedCost: 'Generated Cost:',
      generatedCostInfo: 'Based on hourly rate set for this project',
      archive: 'Archive',
      edit: 'Edit',
      delete: 'Delete',
      reactivate: 'Reactivate',
      archiveProjectModalTitle: 'Archive this project?',
      archiveProjectModalBody:
        'Archived projects are still accessible from your project list and history will still be visible.',
      reactivateProjectModalTitle: 'Reactivate this project?',
      reactivateProjectModalBody:
        'This project will once again be available to log time against.',
      deleteProjectModalTitle: 'Delete this project?',
      deleteProjectModalBody:
        'Once deleted this project will no longer be available and it’s history will be removed.',
      disconnect: 'Disconnect',
      disconnectInfo:
        'Disconnecting from this project will not delete your information. To reconnect you will need to contact the projects owner for a new invitation.',
      disconnectProjectModalTitle: 'Leave this project?',
      disconnectProjectModalBody:
        'You will be disconnected from the project and your information will no longer be shared with the project owner. Logs made on your app will still be accessible as a personal project.',
    },
  });

  static PROJECT_CREATE = new LocalizedStrings({
    'en-US': {
      addProject: 'Add Project',
      projectName: 'Project Name',
      colorPickerHint:
        'Choose color by hovering the box and click to lock the color.',
      notes: 'Notes:',
      hourlyRate: 'Hourly Rate',
      currency: 'Currency',
      createProject: 'Create Project',
    },
  });

  static PROJECT_EDIT = new LocalizedStrings({
    'en-US': {
      editProject: 'Edit Project',
      saveChanges: 'Save Changes',
    },
  });

  static SETTINGS = new LocalizedStrings({
    'en-US': {
      yourInformation: 'Your Information',
      applyChanges: 'Apply Changes',
      bugMeTitle: 'Bug me to log time...',
      hourly: 'Every hour',
      biHourly: 'Every other hour',
      twicePerDay: 'Twice a day',
      endOfDay: 'End of my day',
      daysTitle: 'On these days...',
      startingTitle: 'Day starting at...',
      untilTitle: 'Day ending at...',
      pauseNotifications: 'Pause Notifications',
      resumeNotifications: 'Resume Notifications',
      defaultCurrencyTitle: 'Default currency:',
      incrementTitle: 'Time increment',
      increment5Minutes: '5 min',
      increment15Minutes: '15 min',
      increment30Minutes: '30 min',
      increment60Minutes: '1 hr',
      deleteAccount: 'Delete Your iworkie Account',
      moreiworkie: 'More iworkie',
      moreSupport: 'Support',
      moreSupportInfo:
        'We are here to help if you have a question or need help with the product. Feel free to drop us an email!',
      moreSupportEmail: 'support@iworkie.com',
      moreTerms: 'Terms of Service',
      morePrivacy: 'Privacy Policy',
      deleteAccountPromptTitle: 'Delete Your Account?',
      deleteAccountPromptBody:
        'If you are sure you want to remove your information then enter your password below to confirm.',
    },
  });

  static ERROR = new LocalizedStrings({
    'en-US': {
      defaultTitle: 'Houston, we have a problem!',
      defaultBody:
        'Something went wrong. Please check your network settings and try again.',
      createUser:
        'We seem to be having issues while creating your account. Please check your network settings and try again.',
      noConnection:
        'We can’t seem to find a network. Please check you network settings and try again.',
      loginValidation: 'Email address or password cannot be empty.',
      loginInvalidEmail: 'The email address entered is invalid.',
      loginUserDisabled: 'The email address entered has been disabled.',
      loginUserNotFound:
        'We cannot find an account associated with the email address entered.',
      loginWrongPassword:
        'The entered password does not match the password associated with the email address.',
      tooManyAttempts:
        'Too many attempts to login. We’ve blocked access for a short while so you can track down those correct credentials. Please try again later.',
      weakPassword:
        'The password entered is too weak. Please enter a new password and try again.',
      emailAlreadyInUse:
        'There appears to be an account already associated with this email address. Log in or create an account using an alternative email address.',
      forgotPasswordEmailEmpty:
        'Email cannot be empty. Please check email and try again.',
      deleteAccount:
        'We had a problem deleting your account. Please try again later.',
      projectNameEmpty: 'Please give project a name.',
      projectNameExists: 'Project with this name already exists.',
      migration:
        'Something went wrong. Please check you have active network and try again. If the problem persists, please contact our customer support email at support@iworkie.com',
      invitationTokenNotFoundTitle: 'Project Connection Failed',
      invitationTokenNotFound:
        'The link used to join this project has already been used or has expired. Please contact the project owner to receive a new invitation.',
    },
  });

  static CURRENCIES = new LocalizedStrings({
    'en-US': {
      dollar: '$ Dollar',
      dollarCode: 'USD',
      euro: '€ Euro',
      euroCode: 'EUR',
      yen: '¥ Yen',
      yenCode: 'JPY',
      pound: '£ Pound',
      poundCode: 'GBP',
      ruble: '₽ Ruble',
      rubleCode: 'RUB',
      rupee: '₹ Rupee',
      rupeeCode: 'INR',
      rial: '﷼ Rial',
      rialCode: 'IRR',
    },
  });

  static EXPORT = new LocalizedStrings({
    'en-US': {
      project: 'Project',
      date: 'Date',
      time: 'Time',
      hours: 'Hours',
      rawHours: 'Raw Hours',
      hourlyRate: 'Hourly rate',
      cost: 'Cost',
      currency: 'Currency',
      notes: 'Notes',
      total: 'Total',
    },
  });

  static INVITATION = new LocalizedStrings({
    'en-US': {
      getStarted: 'Get Started!',
      or: 'OR',
      selectProject:
        'Select a personal project and connect all new logs to your new shared project.',
      chooseProject: 'Choose project...',
      merge: 'Merge',
    },
  });

  static WORK_LOGS_PER_DAY = new LocalizedStrings({
    'en-US': {
      projectTimeline: 'Project Timeline',
      addNewLog: 'Add New Log',
    },
  });
}

export default Strings;



// WEBPACK FOOTER //
// ./src/common/Strings.js